import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  const location = useLocation();

  if (admin === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-gray-50"
        data-testid="admin-auth-loading"
      >
        <div className="text-sm text-gray-500">Checking session…</div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
